var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 0C31.0378 0 40 8.96224 40 19.999C40 31.0378 31.0378 40 19.999 40C8.96224 40 0 31.0378 0 19.999C0 8.96224 8.96224 0 19.999 0ZM19.999 17.8705L14.5556 12.4251C14.2636 12.133 13.8775 11.987 13.4934 11.987C12.6852 11.987 11.993 12.6352 11.993 13.4854C11.993 13.8715 12.139 14.2536 12.4311 14.5476L17.8765 19.993L12.4191 25.4504C12.125 25.7444 11.979 26.1305 11.979 26.5126C11.979 27.3668 12.6792 28.013 13.4814 28.013C13.8655 28.013 14.2496 27.867 14.5416 27.5749L19.999 22.1175L25.4584 27.5749C25.7504 27.867 26.1345 28.013 26.5186 28.013C27.3208 28.013 28.019 27.3668 28.019 26.5126C28.019 26.1305 27.873 25.7444 27.5789 25.4504L22.1235 19.993L27.5589 14.5576C27.851 14.2636 27.997 13.8815 27.997 13.4954C27.997 12.6452 27.3048 11.995 26.4966 11.995C26.1125 11.995 25.7264 12.141 25.4344 12.4351L19.999 17.8705Z",
    fill: "#0466C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCloseIcon);
export default __webpack_public_path__ + "static/media/menu-close-icon.004c037d5a17f1919b4124c16389e33e.svg";
export { ForwardRef as ReactComponent };